export const setPageTitle = (
  title: string,
  suffix: string = ' | GYYM (都度利用サービス)'
) => {
  if (typeof document === 'undefined') return

  document.title = `${title}${suffix}`
}

const META_TAG_TRACKING_ATTRIBUTE = 'data-tracked-meta' as const

export interface Meta {
  name: string
  [attr: string]: string | string[]
}

export const setPageMeta = (metaTags: Meta[]) => {
  if (typeof document === 'undefined') return

  // 既に存在するmetaタグの削除
  const currentMetaTags = Array.prototype.slice.call(
    document.querySelectorAll(`[${META_TAG_TRACKING_ATTRIBUTE}]`)
  )
  currentMetaTags.forEach((t) => t.parentNode.removeChild(t))

  metaTags.forEach((attrs) => {
    // metaタグを生成する
    const t = document.createElement('meta')

    Object.entries(attrs).map(([key, value]) => {
      t.setAttribute(key, Array.isArray(value) ? value.join(',') : value)
    })

    // 追加したmetaタグの追跡用
    t.setAttribute(META_TAG_TRACKING_ATTRIBUTE, '')

    // headに追加する
    document.head.appendChild(t)
  })
}

// 現在セットされているtitleタグの値を取得する
export const getPageTitle = (): string => {
  if (typeof document === 'undefined') return ''
  return document.title
}

// 現在セットされているmetaタグの情報を取得する
export const getPageMeta = (): Meta[] => {
  const currentMetaTags = Array.prototype.slice.call(
    document.querySelectorAll(`[${META_TAG_TRACKING_ATTRIBUTE}]`)
  )
  return currentMetaTags.map((t) => {
    const attributes = Array.prototype.slice.call(t.attributes)
    return attributes.reduce(
      (acc: { [k: string]: string }, attr: { name: string; value: string }) =>
        attr.name === META_TAG_TRACKING_ATTRIBUTE
          ? acc
          : {
              ...acc,
              [attr.name]: attr.value,
            },
      {}
    )
  })
}
